import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { useMutation } from '../../../Shared/api';
import { useNotifier } from '../../../Shared/Notifier/NotificationProvider';
import { useRouter } from '../../router';
import { SharedProps } from '../../types';
import Container from '../../UI/Container';
import Layout from '../../UI/Layout';
import EditProjectForm, { EditProjectFormProps } from './EditProjectForm';
import { ProjectLayout } from './ProjectLayout';

export interface EditProjectPageProps extends SharedProps {
  project: EditProjectFormProps['project'];
  users: EditProjectFormProps['users'];
}

export default function EditProjectPage({
  project,
  users,
  charity,
}: EditProjectPageProps) {
  const { t } = useTranslation();
  const { routes } = useRouter();
  const notifier = useNotifier();

  const [editProject, { errors, loading, formKey }] = useMutation(
    routes.edit_project(project.id),
    {
      onSuccess: () => {
        notifier.notify(t('backend:project_saved'));
      },
    }
  );

  return (
    <Container>
      <EditProjectForm
        project={project}
        users={users}
        charity={charity}
        onSubmit={editProject}
        serverErrors={errors}
        loading={loading}
        key={formKey}
      />
    </Container>
  );
}

EditProjectPage.layout = (page: ReactNode) => <Layout><ProjectLayout>{page}</ProjectLayout></Layout>;
